import React from "react";

interface CardComponentProps {
    title?: string;
    description?: string;
    className?: string;
    actions?: React.ReactNode;
    showHeaderBgColor?: boolean;
}

const CardComponent = (props: React.PropsWithChildren<CardComponentProps>) => {

    const {title, actions, className, children, description, showHeaderBgColor} = props;

    return (
        <div className={`card-component ${className}`}>
            {(title || actions) && <div className={`card-header +  ${showHeaderBgColor ? "showHeaderBgColor" : ''} `}>
                <div className="card-title-description-wrapper">
                    <div className="card-title">
                        {title}
                    </div>
                    <div className="card-description">{description}</div>
                </div>
                {
                    actions && <div className="card-actions">
                        {actions}
                    </div>
                }
            </div>}
            {
                (React.Children.count(children)) > 0 && <div className="card-body">
                    {children}
                </div>
            }
        </div>
    );

};

export default CardComponent;
